// extracted by mini-css-extract-plugin
export default {"langSwitcher":"LanguageSwitcher_langSwitcher__obTsc","langSwitcherButton":"LanguageSwitcher_langSwitcherButton__xbFbB","tickIcon":"LanguageSwitcher_tickIcon__drxZW"};